import { useEffect, useState } from 'react';

import useAxios from '../Hooks/UseAxios';
import { MovieShowTime } from '../assets/MovieShowTime';
import Loader from '../common/Loader';
import Schedule from '../components/Schedule';
import ShowTimeDetails from '../components/ShowTimeDetails';
import '../style/ShowTime.css';
const ShowTime = () => {
  const [showLoader, setShowLoader] = useState(true);
  const showTime = useAxios([]);

  useEffect(() => {
    const data = {
      date_from: '2023-08-17',
      date_to: '2023-08-23',
      location: '2',
    };
    showTime.fetcher({
      options: {
        // url: '/api/v1/movie-show-time',
        data,
        method: 'post',
        headers: {
          Authorization: `Bearer ${JSON.parse(
            localStorage.getItem('tokenCineplex')
          )}`,
        },
      },
    });
  }, []);

  setTimeout(() => {
    setShowLoader(false);
  }, 1000);

  return (
    <div>
      {showLoader && (
        <div className='inline-block'>
          <Loader />
        </div>
      )}

      {!showLoader && (
        <div className='my-auto'>
          {MovieShowTime &&
            MovieShowTime?.map((item, index) => (
              <div
                className='my-3 bg-colorThree '
                key={item?.id}
              >
                <div className='grid lg:grid-cols-8 md:grid-cols-6'>
                  <div className='lg:col-span-1 md:col-span-3 mx-10 sm:mx-0 col-span-12  flex items-center border-r-2 border-[#39353c]  '>
                    <img
                      src={item?.movie_detail?.img}
                      alt=''
                      className='px-2 w-full'
                    />
                  </div>

                  <div className='lg:col-span-2 md:col-span-3 col-span-12 border-r-2 border-[#39353c]  text-white px-5 py-10'>
                    <ShowTimeDetails
                      movie_detail={item?.movie_detail}
                      item={item?.id}
                    />
                  </div>
                  <div className='lg:col-span-5 col-span-12 '>
                    <Schedule item={item?.show_time} />
                  </div>
                </div>
              </div>
            ))}
        </div>
      )}
    </div>
  );
};

export default ShowTime;
